import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Oauth2TokenService } from "../../../../../services/oauth2-token.service";
import { environment } from "../../../../../environments/environment";

import { EspecialidadeMedica } from "../models/especialidade-medica";
import { Procedimento } from "../models/procedimento";
import { Pagination } from "../models/pagination";
import { SearchResult } from "../models/search-result";
import { HttpInterceptor } from "../../../../shared/interceptors/http-interceptor.service";
import { HttpHeaders, HttpParams } from "@angular/common/http";

@Injectable()
export class EspecialidadeMedicaService {
  private especialidadeMedicaUrl: string;
  private procedimentoUrl: string;
  especialidadeMedicaProcedimentoUrl: string;
  especialidadeMedica: EspecialidadeMedica[] = [];
  pagination: Pagination[] = [];

  constructor(
    private http: HttpInterceptor,
    private router: Router,
    private oauth2Token: Oauth2TokenService
  ) {
    this.especialidadeMedicaUrl =
      environment.api.base_url + "/api/v1/especialidade_medica";
    this.especialidadeMedicaProcedimentoUrl =
      environment.api.base_url + "/api/v1/especialidade_medica_procedimento";
    this.procedimentoUrl = environment.api.base_url + "/api/v1/procedimento";
  }

  getSearchResult(params?: HttpParams): Promise<SearchResult> {
    const headers = this.getHeaders();
    return this.http
      .get(this.especialidadeMedicaUrl, { headers, params })
      .toPromise()
      .then((response) => {
        let result = new SearchResult();
        let responseJson = response;
        result.especialidadeMedica = responseJson.data as EspecialidadeMedica[];
        result.pagination = responseJson.meta.pagination as Pagination;
        return result;
      })
      .catch(this.handleError);
  }

  getProcedimentosRelacionados(params?: HttpParams): Promise<SearchResult> {
    return this.http
      .get(this.especialidadeMedicaProcedimentoUrl, {
        params,
        headers: this.getHeaders(),
      })
      .toPromise()
      .then((response) => {
        let result = new SearchResult();
        let responseJson = response;
        result.especialidadeMedica = responseJson.data as EspecialidadeMedica[];
        result.pagination = responseJson.meta.pagination as Pagination;
        return result;
      })
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error("An error occurred", error); // for demo purposes only
    return Promise.reject(error.message || error);
  }

  getProcedimentos(params?: HttpParams): Promise<SearchResult> {
    return this.http
      .get(this.procedimentoUrl, { params, headers: this.getHeaders() })
      .toPromise()
      .then((response) => {
        let result = new SearchResult();
        let responseJson = response;
        result.procedimentos = responseJson.data as Procedimento[];
        result.pagination = responseJson.meta.pagination as Pagination;
        return result;
      })
      .catch(this.handleError);
  }

  getEspecialidadeMedica(id: string): Promise<EspecialidadeMedica> {
    let params = new HttpParams().set("id", id);

    return this.getSearchResult(params).then((result) =>
      result.especialidadeMedica.find(
        (especialidadeMedica) => especialidadeMedica.id === id
      )
    );
  }

  update(especialidadeMedica: EspecialidadeMedica): Promise<void> {
    const url = `${this.especialidadeMedicaUrl}/${especialidadeMedica.id}`;
    return this.http
      .put(url, JSON.stringify(especialidadeMedica), {
        headers: this.getHeaders(),
      })
      .toPromise()
      .then((res) => res);
  }

  create(codigo: string, nome: string): Promise<EspecialidadeMedica> {
    return this.http
      .post(
        this.especialidadeMedicaUrl,
        JSON.stringify({ codigo: codigo, nome: nome }),
       { headers: this.getHeaders()}
      )
      .toPromise()
      .then((res) => res);
  }

  createProcedimentosRelacionados(
    especialidade_medica_id: string,
    procedimento_id: string
  ): Promise<EspecialidadeMedica> {
    return this.http
      .post(
        this.especialidadeMedicaProcedimentoUrl,
        JSON.stringify({
          especialidade_medica_id: especialidade_medica_id,
          procedimento_id: procedimento_id,
        }),
       { headers: this.getHeaders()}
      )
      .toPromise()
      .then((res) => res);
  }

  delete(id: string): Promise<void> {
    const url = `${this.especialidadeMedicaUrl}/${id}`;
    return this.http
      .delete(url,{ headers: this.getHeaders()})
      .toPromise()
      .then((res) => {
        let responseJson = res;
        this.router.navigate(["/pages/especialidade-medica/"]);
      });
  }

  deleteProcedimentoRelacionado(id: string): Promise<void> {
    const url = `${this.especialidadeMedicaProcedimentoUrl}/${id}`;
    return this.http
      .delete(url,{ headers: this.getHeaders()})
      .toPromise()
      .then((res) => {
        let responseJson = res;
      });
  }

  getHeaders() {
    const accessToken = this.oauth2Token.getTokens().accessToken;

    return new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    });
  }
}
